import axios from "axios";

export const sendOnboardOtp = async (payload: {}) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/clients/user/send-verification-code`,

      payload,
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (response.data.statusCode === "OK") {
      return true;
      // localStorage.setItem("companyName", response.data.data.companyName);
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during campaign form submit:", error);
    return false;
  }
};

export const submitOnboardForm = async (payload: {}): Promise<any> => {
  try {
    const response = await axios.post(
      `${
        import.meta.env.VITE_BASE_URL
      }/clients/company/profile/create/verify/user`,

      payload,
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (response.data.statusCode === "OK") {
      return response;
      // localStorage.setItem("companyName", response.data.data.companyName);
    } else {
      return response;
    }
  } catch (error) {
    console.error("Error during campaign form submit:", error);
    return error;
  }
};
